export function getEntityId(entity) {
    if (typeof entity === 'string') {
        return entity;
    }
    return entity?.id ?? entity?._id ?? null;
}
export function getEntityName(entity) {
    return typeof entity === 'object' && entity !== null ? (entity.name ?? null) : null;
}
export function getTransactionLabel(transaction) {
    const note = transaction.note?.trim();
    if (note !== undefined && note.length > 0) {
        return note;
    }
    const categoryName = getEntityName(transaction.category);
    if (categoryName !== null && categoryName.trim().length > 0) {
        return categoryName;
    }
    const labels = { expense: 'Expense', income: 'Income', transfer: 'Transfer' };
    return labels[transaction.type];
}
//# sourceMappingURL=entities.js.map